module.exports = __webpack_public_path__ + "img/Moj_Title_Icon.f5fd7c2f.svg";